module.exports = __webpack_public_path__ + "static/media/5.9a10c202.jpg";